import React from 'react';
import styles from './SocialLinks.module.scss';
import { ReactComponent as FacebookIcon } from "../../../../assets/icons/facebook-icon.svg";
import { ReactComponent as GoogleIcon } from "../../../../assets/icons/google-icon.svg";
import { useTranslation } from 'react-i18next';

interface Props {
  additionalText?: string
}

function SocialLinks({ additionalText = '' }: Props) {
  const { t } = useTranslation();
  return(
    <div className={styles.container}>
      <span className={styles.top}>{additionalText}</span>
      <div className={styles.links}>
        <a className={styles.link} href={'http://facebook.com'} target={'_blank'} rel={'noreferrer'}>
          <div className={styles.icon}>
            <FacebookIcon/>
          </div>
          <span className={styles.text}>{t('login.action.socials.facebook')}</span>
        </a>
        <div className={styles.divider}/>
        <a className={styles.link} href={'http://google.com'} target={'_blank'} rel={'noreferrer'}>
          <div className={styles.icon}>
            <GoogleIcon/>
          </div>
          <span className={styles.text}>{t('login.action.socials.google')}</span>
        </a>
      </div>
    </div>

  )
}

export default SocialLinks;
